<template>
  <el-datepicker
    :type="type"
    :range-separator="rangeSeparator"
    :value="jsDateValue"
    :format="datePickerFormat"
    :disabled="disabled"
    class="date-picker"
    @input="handleChange($event)"
  ></el-datepicker>
</template>

<script>
import { DatePicker } from "element-ui";
import { DateTime } from "luxon";

export default {
  components: {
    "el-datepicker": DatePicker
  },
  props: {
    type: {
      type: String,
      default: "date"
    },
    rangeSeparator: {
      type: String,
      default: "-"
    },
    value: {
      type: [Object, Array],
      default: null
    },
    format: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    datePickerFormat() {
      if (!this.format) {
        return "dd MMMM yyyy";
      }

      return this.format;
    },
    jsDateValue() {
      if (!this.value) {
        return null;
      }

      if (Array.isArray(this.value)) {
        return this.value.map(this.toTHJSDate);
      }

      return this.toTHJSDate(this.value);
    }
  },
  methods: {
    toTHJSDate(dateTime) {
      return dateTime.setZone("Asia/Bangkok").toJSDate();
    },
    toDateTimeUTC(jsDate) {
      if (!jsDate) {
        return null;
      }

      return DateTime.fromJSDate(jsDate).toUTC();
    },
    toEndOfDayUTC(jsDate) {
      if (!jsDate) {
        return null;
      }

      return DateTime.fromJSDate(jsDate)
        .setZone("Asia/Bangkok")
        .endOf("day")
        .toUTC();
    },
    handleChange(value) {
      if (Array.isArray(value)) {
        const [start, end] = value;

        this.$emit("input", [
          this.toDateTimeUTC(start),
          this.toEndOfDayUTC(end)
        ]);
        return;
      }

      this.$emit("input", this.toDateTimeUTC(value));
    }
  }
};
</script>

